import * as React from "react";
import TextareaAutosize, {
  TextareaAutosizeProps,
} from "@mui/base/TextareaAutosize";
import { useFormGroup } from "./formGroup";
import { BaseInput } from "./input";
import { styled } from "utils";

const BaseTextarea = styled(BaseInput, {
  resize: "none",
  paddingY: "$3",
  variants: { error: { true: { borderColor: "$error" } } },
});

type Props = TextareaAutosizeProps;
type Ref = HTMLTextAreaElement;

const Textarea: React.FC<Props> = React.forwardRef<Ref, Props>((props, ref) => {
  const { error } = useFormGroup();
  return (
    <BaseTextarea
      as={TextareaAutosize}
      ref={ref}
      error={Boolean(error)}
      minRows={4}
      {...props}
    />
  );
});

Textarea.displayName = "Textarea";

export { Textarea };
